import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { registerServiceWorker } from './pwa';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// A new build is applied on the next navigation rather than mid-session: the
// clock is running and reloading underneath someone mid-shift is worse than
// serving them yesterday's bundle for another minute.
registerServiceWorker((applyUpdate) => {
  window.addEventListener('pagehide', applyUpdate, { once: true });
});
